var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M22 11.366v10.209l-1.415-.774-1.893-1.027h-6.993a2.14 2.14 0 0 1-2.147-2.138v-4.081h4.081c.58 0 1.1-.235 1.486-.611a2.09 2.09 0 0 0 .652-1.527V9.22h4.081a2.088 2.088 0 0 1 1.517.631c.386.387.63.926.63 1.516z",
    fill: "url(#urt5zuzuva)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M18.438 9.219c1.19 0 2.147.967 2.147 2.147v9.435l1.415.774V11.366c0-1.19-.957-2.147-2.148-2.147h-1.415z",
    fill: "url(#ehp53t3f4b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M14.183 19.723h-1.476v.05h1.476v-.05z",
    fill: "url(#cad3lkmscc)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M14.438 3.774v7.643c0 1.181-.957 2.138-2.138 2.138H5.308L2 15.356V5.137C2 3.957 2.957 3 4.137 3h9.527c.428 0 .774.346.774.774z",
    fill: "url(#sb6ajuposd)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M5.562 3c-1.19 0-2.147.967-2.147 2.148v9.435L2 15.356V5.148C2 3.967 2.957 3 4.148 3h1.414z",
    fill: "url(#6tolnpw3pe)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M11.293 13.504H9.817v.05h1.476v-.05z",
    fill: "url(#hvofdznwtf)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.908 6.796H12.3M5.908 9.758H12.3M22 11.52v10.066l-1.415-.773-1.893-1.028H10.52a2.298 2.298 0 0 1-2.3-2.3v-3.92h5.415c.58 0 1.099-.233 1.486-.61a2.09 2.09 0 0 0 .651-1.527V9.23H19.7c1.272 0 2.3 1.028 2.3 2.29zm-6.219-7.756v7.492c0 1.272-1.028 2.3-2.3 2.3H5.308L2 15.356V5.3C2 4.028 3.028 3 4.3 3h10.718c.427 0 .763.346.763.763z",
    stroke: "url(#czztaoobdg)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "urt5zuzuva",
    x1: 9.552,
    y1: 16.404,
    x2: 21.886,
    y2: 12.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ehp53t3f4b",
    x1: 18.438,
    y1: 16.404,
    x2: 22.315,
    y2: 16.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cad3lkmscc",
    x1: 12.707,
    y1: 19.752,
    x2: 12.725,
    y2: 19.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sb6ajuposd",
    x1: 2,
    y1: 10.185,
    x2: 14.326,
    y2: 6.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "6tolnpw3pe",
    x1: 2,
    y1: 10.185,
    x2: 5.877,
    y2: 9.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hvofdznwtf",
    x1: 9.817,
    y1: 13.534,
    x2: 9.835,
    y2: 13.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "czztaoobdg",
    x1: 2,
    y1: 13.807,
    x2: 21.548,
    y2: 6.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsIcon);
export default __webpack_public_path__ + "static/media/smsIcon.f6669f0a1aa6868793817ed6a9d33a37.svg";
export { ForwardRef as ReactComponent };